export default {"src":"/_next/static/media/GEN.7823dc24.svg","height":18,"width":18};